import { Link } from "react-router-dom";
import StatusPageLayout from "../../components/StatusPageLayout";

export const PageForbidden = () => (
  <StatusPageLayout
    // code="403"
    title={"Forbidden"}
    message={
      <>
        The page you’re trying to access has restricted access.
        <br />
        Please refer to the <Link to="/help">help page</Link>.
      </>
    }
  />
);
